import React, { useEffect, useState } from "react";
import { api_Routes } from "../../tools/api_Routes";
import { Helper } from "../../tools/Helper";
import Setting from "../../UI/Settings";

const SettingsPage = () => {
  const [data, setData] = useState();
  useEffect(() => {
    const getData = async () => {
      const { response } = await Helper.Get({
        url: `${api_Routes.Settings.View}`,
        hasToken: true,
      });
      if (response) {
        setData(response.message.result);
        console.log(response.message.result);
      }
    };
    getData();
  }, []);
  return <Setting data={data} />;
};

export default SettingsPage;
